import { render } from "./HomePage.vue?vue&type=template&id=84fd0b0a&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=84fd0b0a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-84fd0b0a"

export default script